/**
 * loadingindicator.js
 * Created by calhosh on 11/6/2019.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@ey/canvascoreservices/LoadingIndicator';

export default function LoadingIndicator(props) {
	const {show, fullscreen, view, styleName, tip, variant, size} = props;
	return <Loader show={show} fullscreen={fullscreen} view={view} styleName={styleName} tip={tip} variant={variant ? variant : 'circular'} size={size} />;
}
LoadingIndicator.propTypes = {
	show: PropTypes.bool,
	fullscreen: PropTypes.bool,
	view: PropTypes.string,
	styleName: PropTypes.string,
	indicatorType: PropTypes.string,
	label: PropTypes.string,
	remFontSize: PropTypes.string,
	size: PropTypes.string
};
